module.exports = "/_next/static/images/calendar-a54c7df037e1ea6d78d6ba642929cf7e.svg";